//images associates
import ispoLogo from "../../images/associates/ispo-logo.png";
import tobiasGrober from "../../images/associates/tobias_grober-avatar.png";
import bangladeshApparelIcon from "../../images/associates/bangladeshapparelexchange.png";
import mostafizUdin from "../../images/associates/mostafiz-uddin-266x266.jpeg";
import oeko from "../../images/associates/oeko.svg";
import georg from "../../images/associates/georg-dieners-266x266.jpg";
import iafLogo from "../../images/associates/iaf_logo.png";
import matthijs from "../../images/associates/matthijs-crietee-300x300-266x266.jpg";
import wrap from "../../images/associates/wrap-testimonial.png";
import avedis from "../../images/associates/avedis-h-seferian-1-266x266.jpg";
import dtb from "../../images/associates/dtb.png";
import susanne from "../../images/associates/dtb-avatar-1-266x266.jpg";

export const associates = (t) => {
    return {
        cardsInfo: {
            associates: [
              {
                logoImg: ispoLogo,
                logoDescription: t("associatesPrincipal.ispoLogo"),
                description: t("associatesPrincipal.ispoDescription"),
                photo: tobiasGrober,
                testimonyName: t("associatesPrincipal.ispoTestimony"),
                title: t("associatesPrincipal.ispoTitle"),
              },
              {
                logoImg: bangladeshApparelIcon,
                logoDescription: t("associatesPrincipal.bangladeshLogo"),
                description:t("associatesPrincipal.bangladeshDescription"),
                photo: mostafizUdin,
                testimonyName: t("associatesPrincipal.bangladeshTestimony"),
                title: t("associatesPrincipal.bangladeshTitle")
              },
              {
                logoImg: oeko,
                logoDescription: t("associatesPrincipal.oekoLogo"),
                description:t("associatesPrincipal.oekoDescription"),
                photo: georg,
                testimonyName: t("associatesPrincipal.oekoTestimony"),
                title: t("associatesPrincipal.oekoTitle"),
              },
              {
                logoImg: iafLogo,
                logoDescription: t("associatesPrincipal.iafLogo"),
                description:t("associatesPrincipal.iafDescription"),
                photo: matthijs,
                testimonyName: t("associatesPrincipal.iafTestimony"),
                title: t("associatesPrincipal.iafTitle"),
              },
              {
                logoImg: wrap,
                logoDescription: t("associatesPrincipal.wrapLogo"),
                description:t("associatesPrincipal.wrapDescription"),
                photo: avedis,
                testimonyName: t("associatesPrincipal.wrapTestimony"),
                title: t("associatesPrincipal.wrapTitle"),
              },
              {
                logoImg: dtb,
                logoDescription: t("associatesPrincipal.dtbLogo"),
                description:t("associatesPrincipal.dtbDescription"),
                photo: susanne,
                testimonyName: t("associatesPrincipal.dtbTestimony"),
                title: t("associatesPrincipal.dtbTitle"),
              },
            ],
            title: {
              text: t("homepage.voicesIndustry"),
              colorClass: "colorDark",
              extraClass: "font40 letterSpacing3",
            },
            textCenter: true,
            separator: true,
          }
    }
};